type FailedResponse = {
  notAuth?: boolean;
  hardError?: boolean;
  softError?: boolean;
  status?: string | number;
  message?: string;
};

/**
 * Why a call failed, as event attributes: `reason` (notAuth, hardError, softError, invalidResponse when it answered
 * without the expected data, or exception), the HTTP `status` when there is one and a short `errorMessage`.
 *
 * @param {FailedResponse} [response] - The api() response, if the call returned one.
 * @param {unknown} [error] - What the catch block received.
 */
export const failureDetails = (response?: FailedResponse, error?: unknown) => {
  const reason = response?.notAuth
    ? 'notAuth'
    : response?.hardError
      ? 'hardError'
      : response?.softError
        ? 'softError'
        : response
          ? 'invalidResponse'
          : 'exception';
  const message = response?.message || (error instanceof Error ? error.message : undefined);
  return {
    reason,
    status: response?.status !== undefined ? `${response.status}` : undefined,
    errorMessage: message ? `${message}`.slice(0, 200) : undefined,
  };
};
